<template>
  <vxe-grid
    auto-resize
    highlight-current-row
    :toolbar-config="tableToolbar"
    border
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    :height="313"
    size="mini"
    @current-change="onChange"
    ref="table"
    highlight-hover-row
    :expand-config="{}"
    :seq-config="{
        startIndex: (page.curPage - 1) * page.pageSize,
      }"
    resizable
  >
    <template #toolbar_form>
      <el-row>
        <el-col></el-col>
        <el-col style="display:flex;" :span="16">
          <el-input
            v-model="searchParams.keyword"
            clearable
            size="mini"
            placeholder="输入订单号查询"
            @keyup.enter.native="getData"
          />
          <el-button class="ml-2" size="mini" type="primary" @click="getData"
            >搜索</el-button
          >
        </el-col>
      </el-row>
    </template>

    <template v-slot:expandContent="{ row }">
      <map-order-table v-if="row.orderNo" :orderNo="row.orderNo" />
    </template>

    <pagination
      size="mini"
      align="right"
      slot="pager"
      :layouts="[
        'Total',
        'Sizes',
        'PrevJump',
        'PrevPage',
        'NextPage',
        'NextJump',
        'FullJump',
      ]"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      @change="handlePaginationChange"
    />
  </vxe-grid>
</template>
<script>
import { initPage } from '@/mixins/base-pagination'
import BaseTable from '@/mixins/base-table'
import MapOrderTable from './map-order-table'
export default {
  components: {
    MapOrderTable,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      page: { ...initPage, pageSize: 5 },
      searchParams: {},
      
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      waybillCode: '',
      tableData: [],
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          type: 'expand',
          align: 'center',
          width: 60,
          title: '展开',
          slots: {
            content: 'expandContent',
          },
        },
        {
          field: 'orderNo',
          title: '订单编号',
          width: 160,
          sortable: true,
          showOverflow: true,
        },
        {
          field: 'transportModeName',
          title: '运输模式',
          minWidth: 100,
          sortable: true,
          showOverflow: true,
        },
        {
          field: 'orderTypeName',
          title: '订单类型',
          minWidth: 100,
          sortable: true,
          showOverflow: true,
        },
        {
          field: 'settlementStatusName',
          title: '结算状态',
          minWidth: 100,
          sortable: true,
          showOverflow: true,
        },
      ],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$api
        .carriageWaybillDetailOrderMapListApi({
          ...this.searchParams,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
          this.page.pageTotal = res.body.count
        })
    },
    onChange({ row }) {
      this.$emit('change', row)
    },
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.getData()
    },
  },
}
</script>
